if (!customElements.get('annais-sticky-purchase')) {
  customElements.define('annais-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-sticky-submit]');
      this.savings = this.querySelector('[data-sticky-savings]');
      this.source = document.getElementById(`shopify-section-${this.dataset.section}`);
      if (!this.source) return;
      this.sync = () => {
        const submit = this.source.querySelector('[id^="ProductSubmitButton-"]');
        const savings = this.source.querySelector('.ap-product-savings');
        if (!submit) { this.button.disabled = true; return; }
        this.button.disabled = submit.disabled || submit.classList.contains('loading') || submit.getAttribute('aria-disabled') === 'true';
        this.button.textContent = (submit.querySelector('span')?.textContent.trim() || submit.textContent.trim()).replace(/\s*€/g, ' €');
        if (this.savings) {
          const amount = savings?.textContent.trim().replace(/^[^\d]*/, '').replace(/\s*€/g, ' €');
          this.savings.hidden = !amount;
          this.savings.textContent = amount ? `${this.dataset.savingsLabel} ${amount}` : '';
        }
      };
      this.onClick = () => {
        const submit = this.source.querySelector('[id^="ProductSubmitButton-"]');
        if (submit && !submit.disabled && !this.button.disabled) submit.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      const info = this.source.querySelector('.wt-product__info');
      if (info) this.observer.observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled','aria-disabled','class'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
